import { Grid } from 'antd';

/**
 * Phone and small-tablet layout (Ahmed, decision M5 "a & b", 2026-10-19): below antd's `lg` breakpoint
 * (992 px), the same width at which the app shell swaps the side menu for a drawer. Before antd has
 * measured the screen (first render) the window width decides, so desktops never flash the card view.
 */
export function useCompactLayout(): boolean {
  const screens = Grid.useBreakpoint();
  if (screens.lg === undefined) return typeof window !== 'undefined' && window.innerWidth < 992;
  return !screens.lg;
}
